import Registry from 'digimaker-ui/Registry';
import User from './view/User';
import StudentFilter from './student/Filter';
import NameFilter from './NameFilter';
import Teacher from './access/Teacher';
import BulkDelete from './student/BulkDelete';


Registry.register( 'filter', 'student', StudentFilter );
Registry.register( 'filter', 'name', NameFilter );

Registry.register( 'view', 'user', User );

Registry.register( 'access', 'parameters-teacher', Teacher );

Registry.register( 'action', 'delete-selected', BulkDelete );